module.exports = __webpack_public_path__ + "img/chevron-left.90813957.svg";